import { observer } from "mobx-react";
import { Grid, makeStyles } from "@material-ui/core";
import { MessageStore } from "store";
import { PageLoading } from "../Page";

const useStyles = makeStyles({
  root: {
    width: "100vw",
    height: "100vh",
    position: "absolute",
    top: 0,
    left: 0,
    background: "rgba(255, 255, 255, 0.6)",
    zIndex: 5,
    opacity: 0.6,
  },
});

export const SystemLoading = observer(() => {
  const classes = useStyles();
  const loading = MessageStore.isLoading;

  if (!loading) return <></>;

  return (
    <Grid container className={classes.root}>
      <PageLoading />
    </Grid>
  );
});
